import React, { FC, Fragment, useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Button } from 'antd';
import RestructureModal from './RestructureModal';

interface Props {
  projectId: string;
  loan: any;
  transactions: any[];
}
const RestructureButton: FC<Props> = ({ projectId, loan, transactions }) => {
  const intl = useIntl();
  const [restructureModalVisible, setRestructureModalVisible] = useState<any>(false);
  const lastTransaction = transactions ? transactions[0] : {};
  return (
    <Fragment>
      <Button
        style={{
          marginLeft: '8px',
        }}
        type="primary"
        ghost
        onClick={() => setRestructureModalVisible(true)}
      >
        <FormattedMessage id="restructure" />
      </Button>

      <RestructureModal
        projectId={projectId}
        visible={restructureModalVisible}
        onCancel={() => setRestructureModalVisible(false)}
        okText={intl.formatMessage({ id: 'restructure' })}
        cancelText={intl.formatMessage({ id: 'cancel' })}
        lastTransaction={lastTransaction}
        loan={loan}
      />
    </Fragment>
  );
};

export default RestructureButton;
